var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.company
    ? _c(
        "div",
        { staticClass: "w-full" },
        [
          _c(
            "DefaultContentLayout",
            [
              _c("ContractorCollectionFilters", {
                attrs: {
                  currentUserId: _vm.currentUser.id,
                  hideManagersFilter: _vm.isManager,
                  parentInputClass: "pb-3",
                  filters: _vm.directoryFilters,
                  filterClass: "w-max-content",
                },
                on: {
                  filtersChanged: _vm.updateFilters,
                  resetFilters: _vm.resetFilters,
                },
              }),
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: _vm.hasData,
                    loading: _vm.loading,
                    spinnerCentered: "",
                  },
                },
                [
                  _c("ActionPanel", {
                    staticClass: "mb-6",
                    attrs: {
                      total: _vm.paginationConfig.total,
                      pageName: "Total Favorited Resources",
                    },
                  }),
                  _vm.empty
                    ? _c("EmptyListPlaceholder", {
                        attrs: {
                          title: _vm.emptyListPlaceholder,
                          subtitle: _vm.emptyListSubtitle,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageContractors")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          143841379
                        ),
                      })
                    : _vm._e(),
                  _c("ElementsSizeProvider", [
                    _c(
                      "div",
                      { staticClass: "flex flex-wrap gap-4" },
                      _vm._l(_vm.contractors, function (contractor) {
                        return _c("CompanyContractorsCollectionCard", {
                          key: contractor.id,
                          attrs: {
                            filterNotAcessResources: true,
                            contractor: contractor,
                            ratingTotal: contractor.ratingTotal,
                            company: _vm.company,
                            currentUser: _vm.currentUser,
                            managerDatabase: _vm.managerDatabase,
                            userUpdatedDate: contractor.user.updated_at,
                          },
                          on: { cardDataUpdated: _vm.fetchNewRes },
                        })
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c("CardPagination", {
                attrs: { config: _vm.paginationConfig },
                on: {
                  "update:config": function ($event) {
                    _vm.paginationConfig = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }